export default __webpack_public_path__ + "static/media/Version (1) - Early Prop_06.0db9a6b1.jpg";